export enum AudioSizeEnum {
  ONE_HOUR = 3599,
  SIXTY_MINUTES = 3600,
}
